/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CognitoUser } from '../models/CognitoUser';
import type { CognitoUserChangeGroupsRequest } from '../models/CognitoUserChangeGroupsRequest';
import type { CognitoUserChangeStateRequest } from '../models/CognitoUserChangeStateRequest';
import type { CognitoUserPoolType } from '../models/CognitoUserPoolType';
import type { CognitoUserSetGroupsRequest } from '../models/CognitoUserSetGroupsRequest';
import type { CognitoUserSummaryCollection } from '../models/CognitoUserSummaryCollection';
import type { CreateCognitoUserPayload } from '../models/CreateCognitoUserPayload';
import type { InternalUserCollection } from '../models/InternalUserCollection';
import type { MfaSettings } from '../models/MfaSettings';
import type { SetCognitoUserPasswordRequest } from '../models/SetCognitoUserPasswordRequest';
import type { UpdateCognitoUserAttributesRequest } from '../models/UpdateCognitoUserAttributesRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UserAccountsService {
    /**
     * Returns a list of Cognito users
     * @returns CognitoUserSummaryCollection successful operation
     * @throws ApiError
     */
    public static listCognitoUsers({
        userPool,
        email,
        pageToken,
        pageSize,
    }: {
        userPool: CognitoUserPoolType,
        /**
         * contact email filter
         */
        email: string,
        pageToken?: string,
        pageSize?: number,
    }): CancelablePromise<CognitoUserSummaryCollection> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/cognitoUsers/{userPool}',
            path: {
                'userPool': userPool,
            },
            query: {
                'email': email,
                'pageToken': pageToken,
                'pageSize': pageSize,
            },
        });
    }
    /**
     * Create a Cognito user
     * @returns any successful operation
     * @throws ApiError
     */
    public static createCognitoUser({
        userPool,
        requestBody,
    }: {
        userPool: CognitoUserPoolType,
        /**
         * Cognito user to create
         */
        requestBody?: CreateCognitoUserPayload,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/cognitoUsers/{userPool}',
            path: {
                'userPool': userPool,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid parameters`,
            },
        });
    }
    /**
     * Returns details of a Cognito user account
     * @returns CognitoUser successful operation
     * @throws ApiError
     */
    public static getCognitoUser({
        userPool,
        cognitoUsername,
    }: {
        userPool: CognitoUserPoolType,
        cognitoUsername: string,
    }): CancelablePromise<CognitoUser> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/cognitoUsers/{userPool}/{cognitoUsername}',
            path: {
                'userPool': userPool,
                'cognitoUsername': cognitoUsername,
            },
        });
    }
    /**
     * Update account state of Cognito user
     * @returns any successful operation
     * @throws ApiError
     */
    public static changeCognitoUserState({
        userPool,
        cognitoUsername,
        requestBody,
    }: {
        userPool: CognitoUserPoolType,
        cognitoUsername: string,
        requestBody?: CognitoUserChangeStateRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/cognitoUsers/{userPool}/{cognitoUsername}/actions/changeState',
            path: {
                'userPool': userPool,
                'cognitoUsername': cognitoUsername,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Set groups of Cognito user
     * @returns any successful operation
     * @throws ApiError
     */
    public static setCognitoUserGroups({
        userPool,
        cognitoUsername,
        requestBody,
    }: {
        userPool: CognitoUserPoolType,
        cognitoUsername: string,
        requestBody?: CognitoUserSetGroupsRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/cognitoUsers/{userPool}/{cognitoUsername}/actions/setGroups',
            path: {
                'userPool': userPool,
                'cognitoUsername': cognitoUsername,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Change groups of Cognito user (groups from the removeGroups are removed first before groups from addGroups are added)
     * @returns any successful operation
     * @throws ApiError
     */
    public static changeCognitoUserGroups({
        userPool,
        cognitoUsername,
        requestBody,
    }: {
        userPool: CognitoUserPoolType,
        cognitoUsername: string,
        requestBody?: CognitoUserChangeGroupsRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/cognitoUsers/{userPool}/{cognitoUsername}/actions/changeGroups',
            path: {
                'userPool': userPool,
                'cognitoUsername': cognitoUsername,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Updates attributes of a cognito user
     * @returns any successful operation
     * @throws ApiError
     */
    public static updateCognitoUserAttributes({
        userPool,
        cognitoUsername,
        requestBody,
    }: {
        userPool: CognitoUserPoolType,
        cognitoUsername: string,
        requestBody?: UpdateCognitoUserAttributesRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/cognitoUsers/{userPool}/{cognitoUsername}/actions/updateAttributes',
            path: {
                'userPool': userPool,
                'cognitoUsername': cognitoUsername,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Sets user status to CONFIRMED
     * @returns any successful operation
     * @throws ApiError
     */
    public static confirmCognitoUserSignUp({
        userPool,
        cognitoUsername,
    }: {
        userPool: CognitoUserPoolType,
        cognitoUsername: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/cognitoUsers/{userPool}/{cognitoUsername}/actions/confirmSignUp',
            path: {
                'userPool': userPool,
                'cognitoUsername': cognitoUsername,
            },
        });
    }
    /**
     * Sets user password
     * @returns any successful operation
     * @throws ApiError
     */
    public static setCognitoUserPassword({
        userPool,
        cognitoUsername,
        requestBody,
    }: {
        userPool: CognitoUserPoolType,
        cognitoUsername: string,
        requestBody?: SetCognitoUserPasswordRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/cognitoUsers/{userPool}/{cognitoUsername}/actions/setPassword',
            path: {
                'userPool': userPool,
                'cognitoUsername': cognitoUsername,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Disables MFA for a user
     * @returns any successful operation
     * @throws ApiError
     */
    public static disableCognitoUserMfa({
        userPool,
        cognitoUsername,
    }: {
        userPool: CognitoUserPoolType,
        cognitoUsername: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/cognitoUsers/{userPool}/{cognitoUsername}/actions/disableMfa',
            path: {
                'userPool': userPool,
                'cognitoUsername': cognitoUsername,
            },
        });
    }
    /**
     * Changes MFA settings for a user
     * @returns any successful operation
     * @throws ApiError
     */
    public static changeMfaSettings({
        userPool,
        cognitoUsername,
        requestBody,
    }: {
        userPool: CognitoUserPoolType,
        cognitoUsername: string,
        requestBody: MfaSettings,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/cognitoUsers/{userPool}/{cognitoUsername}/actions/changeMfaSettings',
            path: {
                'userPool': userPool,
                'cognitoUsername': cognitoUsername,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Returns list of internal users
     * @returns InternalUserCollection successful operation
     * @throws ApiError
     */
    public static listInternalUsers({
        page,
        limit,
        firstName,
        lastName,
        email,
        status,
    }: {
        /**
         * Sets current page index
         */
        page?: number,
        /**
         * Sets the page size
         */
        limit?: number,
        /**
         * Sets firstName filter
         */
        firstName?: string,
        /**
         * Sets lastName filter
         */
        lastName?: string,
        /**
         * Sets Email filter
         */
        email?: string,
        /**
         * Sets XTRF status filter
         */
        status?: string,
    }): CancelablePromise<InternalUserCollection> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internalUsers',
            query: {
                'page': page,
                'limit': limit,
                'firstName': firstName,
                'lastName': lastName,
                'email': email,
                'status': status,
            },
        });
    }
}
